<template>
  <GMapMap
    :center="startLocation"
    :zoom="15"
    :options="options"
    class="rs-gmaps"
  >
    <GMapMarker
      :position="mapStartLocation(coordinates)"
      :draggable="true"
      :icon="markerOptions"
      @mouseup="updateCoordinates"
    />
  </GMapMap>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsGmaps',

  props: {
    lat: Number,
    lng: Number,
  },
  data() {
    return {
      options: {
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      },
      startLocation: {
        lat: this.lat,
        lng: this.lng,
      },
      coordinates: {
        lat: this.lat,
        lng: this.lng,
      },
      markerOptions: {
        url: '/img/rentsync-pin.png',
        scaledSize: { width: 30, height: 45, f: 'px', b: 'px' },
      },
    };
  },
  watch: {
    lat: {
      handler(newValue) {
        this.refreshCoordinates(newValue, this.lng as number);
      },
    },
    lng: {
      handler(newValue) {
        this.refreshCoordinates(this.lat as number, newValue);
      },
    },
  },
  mounted() {
    this.setCords();
  },
  methods: {
    setCords() {
      if (!this.lat || !this.lng) {
        this.coordinates = {
          lat: 43.13763,
          lng: -79.21505,
        };
        this.startLocation = {
          lat: 43.13763,
          lng: -79.21505,
        };
      }
    },
    updateCoordinates(location: any) {
      this.coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.$emit('updateMap', this.coordinates);
    },
    mapStartLocation(marker: any) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng),
        //--
      };
    },
    /**
     * Updates the coordinates and triggers an event to update the map with the new location.
     *
     * @param {number} latitude - The latitude of the new location.
     * @param {number} longitude - The longitude of the new location.
     */
    refreshCoordinates(latitude: number, longitude:number) {
      this.coordinates = {
        lat: latitude,
        lng: longitude,
      };
      this.startLocation = {
        lat: latitude,
        lng: longitude,
      };
      this.$emit('updateMap', this.coordinates);
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-gmaps {
  width: 100%;
  height: 200px;
  border-radius: $global-radius;
}
</style>
